import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "invalid-content",
  "use": "invalid-content-usage",
  "viewBox": "0 0 241 241",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 241 241\" id=\"invalid-content\"><g data-name=\"Layer 2\" stroke-linecap=\"round\" stroke-width=\"13\"><circle cx=\"120.5\" cy=\"120.5\" r=\"113.54\" fill=\"#fff\" stroke-linejoin=\"round\" /><path fill=\"none\" stroke-miterlimit=\"10\" d=\"M95.2 145.8l50.6-50.6M145.8 145.8L95.2 95.2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol